export const PEOPLE_PICKER_MAX_VISIBLE_AVATARS = 4;
export const PEOPLE_PICKER_AVATAR_PX = 22;
